<template>
  <div>
    <div class="n-radio radio" :class="radioClasses">
        <input :id="rId1"
              type="radio"
              :name="cbId"
              v-model="answer"
              :disabled="disabled"
              value="1"/>
        <label :for="rId1">
          <div class="escala1">1</div>&nbsp;Abaixo do esperado (0 a 50%): Normalmente suas entregas são <b>fora</b> do prazo estipulado, <b>incompletas/inacabadas</b> e <b>abaixo</b> dos padrões de qualidade.
        </label>
    </div>
    <div class="n-radio radio" :class="radioClasses">
        <input :id="rId2"
              type="radio"
              :name="cbId"
              v-model="answer"
              :disabled="disabled"
              value="2"/>
        <label :for="rId2">
          <div class="escala2">2</div>&nbsp;Em desenvolvimento (51 a 79%): Normalmente suas entregas são <b>pacialmente satisfatórias</b> e <b>oscilam</b> entre estarem incompletas/inacabadas, fora do prazo, conforme os padroes de qualidade​.
        </label>
    </div>
    <div class="n-radio radio" :class="radioClasses">
        <input :id="rId3"
              type="radio"
              :name="cbId"
              v-model="answer"
              :disabled="disabled"
              value="3"/>
        <label :for="rId3">
          <div class="escala3">3</div>&nbsp;Dentro do esperado (80 a 100%): Normalmente suas entregas são <b>dentro</b> do prazo, <b>conforme</b> os padrões de qualidade, <b>completas</b> e <b>acabadas</b>.​
        </label>
    </div>
    <div class="n-radio radio" :class="radioClasses">
        <input :id="rId4"
              type="radio"
              :name="cbId"
              v-model="answer"
              :disabled="disabled"
              value="4"/>
        <label :for="rId4">
          <div class="escala4">4</div>&nbsp;Acima do esperado (101 a 120%): Normalmente suas entregas <b>superam</b>, sao antes do prazo estabelecido, com qualidade excepcional, completa e acabada, <b>viabilizando novas alternativas e evolução</b>.
        </label>
    </div>
    <!-- <div class="n-radio radio" :class="radioClasses">
        <input :id="rId5"
              type="radio"
              :name="cbId"
              v-model="answer"
              :disabled="disabled"
              value="5"/>
        <label :for="rId5">
          <div class="escala5">5</div>&nbsp;Normalmente suas entregas <b>superam</b>, são <b>antes</b> do prazo estabelecido, com qualidade <b>excepcional</b>, completa e acabada, <b>viabilizando novas alternativas e evolução</b>.
        </label>
    </div>    -->
  </div> 
</template>
<script>
  export default {
    name: 'evaluation-delivery-answer',
    props: {
      answerEdit: [Number],
      label: [String, Number],
      disabled: [Boolean, String],
      inline: Boolean,
      type: {
        type: String,
        default: 'neutral'
      }
    },
    data () {
      return {
        answer: this.answerEdit,
        cbId: '',
        rId1: '',
        rId2: '',
        rId3: '',
        rId4: '',
        rId5: ''
      }
    },
    computed: {
      inlineClass () {
        if (this.inline) {
          return `radio-inline`
        }
        return ''
      },
      radioClasses () {
        return `radio-${this.type} ${this.inlineClass}`
      }
    },
    created () {
      this.cbId = Math.random().toString(16).slice(2)
      this.rId1 = Math.random().toString(16).slice(2)
      this.rId2 = Math.random().toString(16).slice(2)
      this.rId3 = Math.random().toString(16).slice(2)
      this.rId4 = Math.random().toString(16).slice(2)
      this.rId5 = Math.random().toString(16).slice(2)
    },
    watch: {
      answer (val) {
        let data = {
          answerValue: val
        }
        this.$emit('setEvaluationDeliveryAnswer', data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/EvaluationDeliveryAnswer.vue